import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';

const connectionString = typeof config !== 'undefined' ? config.ai.connectionString : '';

export const applicationInsights = new ApplicationInsights({
  config: {
    autoTrackPageVisitTime: true,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    disableCorrelationHeaders: false,
    distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
    loggingLevelConsole: 2,
    enableAutoRouteTracking: false,
    enableDebug: false,
    connectionString,
  },
});

export const { appInsights } = applicationInsights;
